module.exports = __webpack_public_path__ + "img/2.a1fb50d6.jpg";